
import { Component, Prop, Vue } from 'vue-property-decorator';
import { JobDetailedStop } from '@/models/jobDetailed';

@Component
export default class PreviewJobStopDrawing extends Vue {
  @Prop(Array) public stops: JobDetailedStop[];
}
